var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TabProduct',{attrs:{"component":this}}),_c('TabGeneral',{attrs:{"component":_vm.component}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }